// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"15b73819","192":"15b73819","428":"3a896ea3","584":"15b73819","704":"e61ad6ce","744":"15b73819","816":"e61ad6ce","884":"9fee0c55"}[chunkId] + ".chunk.css";
};